import FOUNDER_PHOTO from "@/assets/Founder_2.png";
import NagalandDirector from "@/assets/Executive_director_of_Nagaland.png";
import RoshanKumar from "@/assets/Roshan_Kumar.png";
import Akumar from "@/assets/A_Kumar.png";
import SeniorAdvisor from "@/assets/Senior_Adviser.png";
import Chingmak from "@/assets/Chingmak .png";

export const TEAM = [
  {
    name: "T G Dey",
    role: "Founder & Managing Director",
    qualifications: "B.E. (Civil), MBA",
    experience: "16 years",
    spec: "Specialisation in policy matter & project management in government and private sector, retails, hospitality, art & culture, sports etc",
    photo: FOUNDER_PHOTO,
    isFounder: true,
  },
  {
    name: "Roshan Kumar Tamang",
    role: "Executive Director Nagaland & Arunachal",
    qualifications: "Bachelor of Art (Political Science)",
    experience: "15 years",
    spec: "Marketing, Business Development, Project Management",
    photo: RoshanKumar,
  },
  {
    name: "Ashish Kumar",
    role: "Chief Consultant",
    experience: "20+ Years",
    spec: "Qualified Solicitor (England) with international legal and commercial expertise across the UK, India, UAE, China & Australia, specializing in Corporate Law, Project Development, Real Estate, Hospitality and Cross-Border Transactions.",
    photo: Akumar,
  },
  {
    name: "Rai Bahadur Kaul",
    role: "Principle chief advisor",
    experience: "40 years",
    spec: "Retired from government of India, Ministry of finance, Disaster Management, Experienced in Rural & Urban local bodies, Policy Matters & Project Management",
    photo: NagalandDirector,
  },
  {
    name: "Skhemborlang Kurbah",
    role: "Civil Engineer",
    qualifications: "M.Sc. (Geoinformatics)",
    experience: "8 years",
    spec: "Executive director of Meghalayan",
    photo: SeniorAdvisor,
  },
  {
    name: "C Chingmak Kumchuba Chang",
    role: "Executive director for Art culture",
    experience: "7 years",
    spec: "Experience in art & culture development",
    photo: Chingmak,
  },
];
